var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 9.63818C12.294 9.63818 12.5882 9.69478 12.882 9.86496L14.9996 10.9996L15 3H9V11L11.1176 9.86536C11.4118 9.69479 11.7056 9.63819 11.9998 9.63819L11.9998 9.63818Z",
    fill: "#0A2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81759 21H19.1435C20.1524 21 21 20.0824 21 18.9902V5.00983C21 3.91762 20.1524 3 19.1435 3H16.3188V11.4756C16.3188 11.8687 16.1169 12.2182 15.8346 12.4367C15.6733 12.5242 15.5117 12.5678 15.3099 12.5678C15.1486 12.5678 14.987 12.5242 14.8257 12.4367L12.001 10.7329L9.17621 12.4367C8.85333 12.6114 8.49021 12.6114 8.16734 12.4367C7.84446 12.2621 7.68317 11.8687 7.68317 11.4756L7.6826 3H4.85784C3.84897 3 3.00138 3.91762 3.00138 5.00983V18.9902C2.96112 20.0824 3.80869 20.9997 4.81756 20.9997L4.81759 21Z",
    fill: "#0A2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.6c4f9f3e6bb31edefaa0c1d1a596b4b0.svg";
export { ForwardRef as ReactComponent };